(function($) {
    // jQuery('#form-valoa-quiz').submit(function(){
    //     alert('send');
    //     return false;
    // });
	jQuery('.valoa-radio-button-wrapper').click(function(){
        var input = jQuery(this).find('input[type=radio]').first();
        jQuery(this).parent().children().each(function(){
            jQuery(this).removeClass('selected');
        });
        jQuery(input).prop("checked", true);
        jQuery(this).addClass('selected');
    });
})( jQuery );